<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">购买时间 : </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">购买人/ID : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight">手机号码 : </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
                
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="type" slot-scope="{ row }">
        <div>
          {{
            row.type == 1
              ? "过载"
              : row.type == 2
              ? "短路"
              : row.type == 3
              ? "漏电"
              : row.type == 4
              ? "断电提醒"
              : row.type == 5
              ? "审核"
              : row.type == 6
              ? "其他"
              : ""
          }}
        </div>
      </template>
       <template slot="price" slot-scope="{ row }">
        <div>
          {{row.price ? '￥'+row.price : ''}}
        </div>
      </template>
      
    </avue-crud>
  </div>
</template>

<script>
import { recordList } from "@/api/service/record";
import dayjs from "dayjs";
import FormEditor from "@/components/formComponents/formEditor";
export default {
  name: "index",
  components: {
    FormEditor,
  },
  data() {
    return {
      searchData: {},
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "用户ID",
            prop: "userId",
          },
          {
            label: "购买用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "购买套餐",
            prop: "packageName",
          },
          {
            label: "支付金额",
            prop: "price",
          },
          {
            label: "购买时间",
            prop: "payTime",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        // sort: " ",
        title: "",
        details: "",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.payTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.payTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      recordList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        // this.resetForm();
      }, 500);
    },
    //编辑
    async handleDetails(row) {
      console.log(row);
      this.dialogVisible = true;
      this.form = { ...row };
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped>
.box_message {
  display: flex;
  justify-content: space-between;
  background: #f2f2f2;
  border-radius: 5px;
  padding: 10px 15px;
}
.box_content {
  margin-top: 15px;
}
</style>